<template>
    <section id="demo" class="demo">
        <h3>{{$t('navigation.demo')}}</h3>
        <div class="container">
            <demo-request-form v-show="step == 'request'" @complete="onRequestComplete"></demo-request-form>
            <demo-code-form  v-show="step == 'code'" :request="request" @complete="onCodeConfirmed" @cancel="step='request'"></demo-code-form>
            <demo-access v-show="step == 'end'" :access="access"></demo-access>
        </div>
    </section>
</template>

<script>
    import DemoRequestForm from './demo-request-form';
    import DemoCodeForm from './demo-code-form';
    import DemoAccess from './demo-access';


    export default {
        name: "demo",
        components: { DemoRequestForm, DemoCodeForm, DemoAccess },
        data() {
            return {
                loading: false,
                request: null,
                access: null,
                step: 'request' // request,code,end
            };
        },
        computed: {

        },

        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            onCodeConfirmed(access) {
                this.step = 'end';
                console.log("onCodeConfirmed", access)
                this.access = access;
            },
            onRequestComplete(request) {
                this.step = 'code';
                this.request = request;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .webp {
        .demo {
            background-image: url('/assets/purple_bg.jpg.webp');

            .container {
                background-image: url('/assets/gift.png.webp');  
            }
        }
    }

    .demo {
        background: url('/assets/purple_bg.jpg');
        background-size: cover;
        background-attachment: fixed;
        color: $white;

        .container {
            background: url('/assets/gift.png');
            background-attachment: scroll;
            background-repeat: no-repeat;
            background-position: bottom left;
            padding-bottom: 4*$spacer;

             @media (max-width: ($tablet)-1) {
                 background-position: 120% 100%;
             }
        }
    }

    h3 {
        font-size: 6rem;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 0;
        margin-bottom: 4*$spacer;
        padding: 4*$spacer $spacer;
        background: $white;
        color: $black;
    }
</style>
